import { combineReducers } from 'redux';
import common from './common';
import trafficLight from './trafficLight';
import multiVehicle from './multiVehicle';
import cockpitRealtime from './cockpitRealtime';
import newCommon from './newCommon';
import issue from './issue';
import login from './login';
import enumTranslator from './enumTranslator';
import commandRes from './commandRes';
import controlBtn from './controlBtn';
import realtime from './realtime';
export const rootReducer = combineReducers({
  common,
  trafficLight,
  multiVehicle,
  cockpitRealtime,
  newCommon,
  issue,
  login,
  enumTranslator,
  commandRes,
  controlBtn,
  realtime,
});
